export default __webpack_public_path__ + "static/media/iconMapPinGradient.24f11fbf.svg";